import React from 'react'


const Analytics: React.FC = () => {
  return (
    <div>Analytics</div>
  )
}

export default Analytics